<template>
  <div class="year-semester">
    <a-select
      class="year-semester-select"
      v-model="yearAndSemester"
    >
      <div class="custom-dropdown" :ref="selectTag" slot="dropdownRender" @mousedown="e => e.preventDefault()">
        <div class="left">
          <div
            v-for="(item, index) in yearData"
            :key="index"
            :class="['item', {'selected': item === year}]"
            @click="() => handleYearClick(item)"
          >
            {{ item }}
          </div>
        </div>
        <div class="right">
          <div
            v-for="(item, index) in semesterData"
            :key="index"
            :class="['item', {'selected': item === semester}]"
            @click="() => handleSemesterClick(item)"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </a-select>
  </div>
</template>
<script>
// import { mapGetters } from 'vuex'
import mixins from '@/utils/mixins'
export default {
  mixins: [mixins],
  props: {
    selectTag: {
      type: String,
      default: 'semester-select-dropdown'
    }
  },
  data() {
    return {
      year: '全部',
      semester: '全部'
    }
  },
  computed: {
    // 学年学期
    yearAndSemester() {
      if (this.year === '全部' || this.semester === '全部') {
        this.$emit('updateYearAndSemester', { year: '', semester: '' })
        return '全部'
      }
      this.$emit('updateYearAndSemester', { year: this.year, semester: this.semester })
      return this.year + ' ' + this.semester
    }
  },
  methods: {
    clearSelect() {
      this.year = '全部'
      this.semester = '全部'
    },
    findVal(arr, actId) {
      const item = arr.find(item => item.id === actId)
      return item.name
    },
    /**
     * @description 修改季节
     */
    handleSemesterClick(val) {
      this.semester = val
    },
    /**
     * @description 修改年
     */
    handleYearClick(val) {
      this.year = val
    }
  }
}
</script>
<style lang="less" scoped>
.year-semester {
  display: inline-block;
}
.year-semester-select,
.ant-select-selection {
  width: 110px;
}
.custom-dropdown {
  display: flex;
  .left, .right {
    height: 200px;
    padding: 8px 0;
    flex: 2;
    text-align: center;
    overflow: auto;
    .item {
      padding: 8px 0;
      &:hover{
        background: #F5F7F9;
      }
      &.selected {
        color: #3262FD;
      }
    }
  }
  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-left: 2px solid #F5F7F9;
  }
}
</style>
